import axios from "axios";

/**
 * Function to get chats from rest API.
 * @param {string} accessToken - The access token for Authorization.
 * @param {string} idToken - The ID token for Authorization.
 * @param {string} sessionId - The session ID for chat
 * @returns {Promise} - Axios response.
 */
export const fetchChatHistory = async (idToken, accessToken, sessionId) => {
  try {
    const url = `${process.env.REACT_APP_API_BASE_URL}/api/chat/history/${sessionId}`;
    const headers = {
      Authorization: `Bearer ${accessToken}`,
      id_token: idToken,
    };
    const response = await axios.get(url, { headers });

    if (response?.data?.history) {
      return response.data.history;
    }
  } catch (error) {
    console.error("Error fetching chat history:", error);
    throw error;
  }
};

export const sendChatMessage = async (
  idToken,
  accessToken,
  sessionId,
  message
) => {
  try {
    const url = `${process.env.REACT_APP_API_BASE_URL}/api/chat/`;
    const headers = {
      Authorization: `Bearer ${accessToken}`,
      id_token: idToken,
    };

    const response = await axios.post(
      url,
      { sessionId, query: message },
      { headers }
    );

    if (response?.data?.response) {
      return response.data.response;
    }
  } catch (error) {
    console.error("Error Sending Chat Message:", error);
    throw error;
  }
};
